
import styles from "./GlobalSearch.module.css";


export default function SearchResults({
  results,
  activeIndex = -1,
  onActiveIndexChange,
  onHotelSelect,
}) {
  const hasResults =
    results.states.length > 0 ||
    results.cities.length > 0 ||
    results.hotels.length > 0;

  // Keep indexes in the same order as GlobalSearch.jsx
  const getIndex = (type, index) => {
    if (type === "state") return index;

    if (type === "city") {
      return results.states.length + index;
    }

    return results.states.length + results.cities.length + index;
  };

  return (
    <div className={styles.results}>
      {!hasResults ? (
        <div className={styles.noResult}>
          <span className={styles.emptyIcon} aria-hidden="true">
            ⌕
          </span>
          <strong>No results found</strong>
          <span>Try another hotel, city or state.</span>
        </div>
      ) : (
        <>
          {results.states.length > 0 && (
            <section className={styles.group}>
              <h3>States</h3>

              {results.states.map((state, index) => {
                const itemIndex = getIndex("state", index);

                return (
                  <div
                    key={state}
                    className={`${styles.item} ${
                      activeIndex === itemIndex ? styles.activeItem : ""
                    }`}
                    onMouseEnter={() => onActiveIndexChange?.(itemIndex)}
                  >
                    <span aria-hidden="true">📍</span>
                    <span>{state}</span>
                  </div>
                );
              })}
            </section>
          )}

          {results.cities.length > 0 && (
            <section className={styles.group}>
              <h3>Cities</h3>

              {results.cities.map((city, index) => {
                const itemIndex = getIndex("city", index);

                return (
                  <div
                    key={city}
                    className={`${styles.item} ${
                      activeIndex === itemIndex ? styles.activeItem : ""
                    }`}
                    onMouseEnter={() => onActiveIndexChange?.(itemIndex)}
                  >
                    <span aria-hidden="true">🏙️</span>
                    <span>{city}</span>
                  </div>
                );
              })}
            </section>
          )}

          {results.hotels.length > 0 && (
            <section className={styles.group}>
              <h3>Hotels</h3>

              {results.hotels.map((hotel, index) => {
                const itemIndex = getIndex("hotel", index);

                return (
                  <button
                    key={hotel.id ?? hotel.slug ?? `${hotel.name}-${index}`}
                    type="button"
                    className={`${styles.hotel} ${
                      activeIndex === itemIndex ? styles.activeHotel : ""
                    }`}
                    onMouseEnter={() => onActiveIndexChange?.(itemIndex)}
                    onClick={() => onHotelSelect?.(hotel)}
                  >
             
<span className={styles.hotelIcon}>
  {hotel.featured_image ? (
    <img
      src={hotel.featured_image}
      alt={hotel.name || "Hotel"}
      loading="lazy"
      onError={(e) => {
        e.currentTarget.style.display = "none";
      }}
    />
  ) : (
    <span className={styles.imagePlaceholder} aria-hidden="true">
      🏨
    </span>
  )}
</span>


                    <span className={styles.hotelInfo}>
                      <strong>{hotel.name || "Unnamed Hotel"}</strong>
                      <span>
                        {[hotel.city, hotel.state]
                          .filter(Boolean)
                          .join(", ") || "Location unavailable"}
                      </span>
                    </span>

                    <span className={styles.arrow} aria-hidden="true">
                      →
                    </span>
                  </button>
                );
              })}
            </section>
          )}
        </>
      )}
    </div>
  );
}
